var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99998 4C4.99998 2.34315 6.34312 1 7.99998 1C9.65683 1 11 2.34315 11 4C11 5.65685 9.65683 7 7.99998 7C6.34312 7 4.99998 5.65685 4.99998 4Z",
    fill: "#010F55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50081 13.4036C2.55237 10.4104 4.99463 8 7.99998 8C11.0054 8 13.4477 10.4105 13.4992 13.4038C13.5026 13.6023 13.3882 13.784 13.2077 13.8668C11.6218 14.5945 9.85766 15 8.00019 15C6.14255 15 4.37827 14.5945 2.79219 13.8666C2.61174 13.7838 2.49739 13.6021 2.50081 13.4036Z",
    fill: "#010F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.70d7cab9b4764c9549ad8cfa79b7ffe9.svg";
export { ForwardRef as ReactComponent };